import React, { Component } from 'react';
import { ContactForm, FormDialog } from '../../molecules';
import { ContactUs } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * The ContactUsQrView us section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class ContactUsQrView extends Component {

	state = {
		showDialog: false,
	}

	handleSuccess = () => {
		this.setState({ showDialog: true });
	}

	handleClose = () => {
		this.setState({ showDialog: false });
	}

	render () {
		const {
			address,
			buttonLabel,
			mapHeading,
			mapQuery,
			termsContent,
			successDialog,
		} = this.props.content.qrLandingPage.contactUs;
		const common = this.props.content.common;

		return (
			<ContactUs
				{...{ address, mapHeading, mapQuery }}
			>
				<FormDialog
					{...successDialog}
					onClose={this.handleClose}
					visible={this.state.showDialog}
				/>
				<ContactForm
					{...{ ...common, buttonLabel, buttonVariant: 'blue', className: 'ContactUsQrView', termsContent }}
					onSuccess={this.handleSuccess}
				/>
			</ContactUs>
		);
	}
}

export default withLanguageContext(ContactUsQrView);



// WEBPACK FOOTER //
// ./src/components/views/ContactUsQrView/ContactUsQrView.js